import { Card } from "@vega-core/components/shadcn/card";
import { m } from "@vega-core/paraglide/messages";
import { SettingsSectionLayout } from "@vega-modules/scenes/Settings/components/SettingsSectionLayout";

import { GPSettingsNotifications } from "../components/GPSettingsNotifications";

export const NotificationsPage = () => (
  <SettingsSectionLayout title={m.titles_notifications()}>
    <Card className="px-6 py-4" noShadow>
      <GPSettingsNotifications />
    </Card>
  </SettingsSectionLayout>
);
